module.exports = __webpack_public_path__ + "static/media/allie04.b29c44a0.jpg";